import MidiEffect from '../effects/midi/MidiEffect';
import Instrument from '../instruments/Instrument';
import MidiToAudioChain from '../core/MidiToAudioChain';
import Track from '../core/Track';
class MIDITrack extends Track {
    constructor() {
        super(...arguments);
        this.chain = new MidiToAudioChain();
    }
    insert(object, position) {
        if (object instanceof Instrument) {
            this.chain.insert(object, position);
        }
        else if (object instanceof MidiEffect) {
            this.chain.insert(object, position);
        }
        else {
            super.insert(object, position);
        }
        return this;
    }
}
export default MIDITrack;
//# sourceMappingURL=MIDITrack.js.map